import type { PlateElementProps } from 'platejs/react';
import { Box, Table, TableContainer, TableBody } from '@mui/material';

export const EditorTable = ({
    children,
    className,
    attributes,
}: PlateElementProps) => (
    <Box className={className} {...attributes} sx={{ mb: 2 }}>
        <TableContainer>
            <Table>
                <TableBody>{children}</TableBody>
            </Table>
        </TableContainer>
    </Box>
);
